export default __webpack_public_path__ + "static/media/reputationSentiment.63f4790d.png";